import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=08fe63fa&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=08fe63fa&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fe63fa')) {
      api.createRecord('08fe63fa', component.options)
    } else {
      api.reload('08fe63fa', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=08fe63fa&", function () {
      api.rerender('08fe63fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/edit.vue"
export default component.exports